import React, {RefObject} from 'react';
import intl from "react-intl-universal";
import {observer} from "mobx-react-lite";

import type {AppState} from "@stores/AppState";

import {useAppState} from "@stores/AppStateContext";

import {ContextMenuInterface} from "../ContextMenuInterface";

import {ContextMenu} from '../../../components/ContextMenu';
import {CameraIcon} from "../../../components/icons/CameraIcon";
import {DeleteIcon} from "../../../components/icons/DeleteIcon";
import {ContextMenuProps} from "../ContextMenuManager";


export interface AvatarUploadContextMenuParams extends ContextMenuInterface {
    onRemoveAvatar: (event: React.MouseEvent<HTMLElement>) => void;
    hasAvatar: boolean;
    fileKeyPart: string;
    fileInputRef: RefObject<HTMLInputElement>;
}

export const openAvatarUploadContextMenu = (appState: AppState, id: string, params: Omit<AvatarUploadContextMenuParams, 'handleClose' | 'isDark'>, isDark?: boolean) => {
    const props: ContextMenuProps = {
        type: 'avatar',
        id: id,
        withOverlay: true,
        isDark: isDark ?? false,
        menuPlacement: 'block-end',
        menuAlignment: 'center',
        VERTICAL_SHIFT: 0,
        withPointer: false,
        params: {...params},
    }
    if (appState.contextMenu) {
        appState.addAdditionalContextMenu(props);
    } else {
        appState.setContextMenu(props);
    }
};

export const AvatarUploadContextMenu = observer(
    ({
         onRemoveAvatar,
         hasAvatar,
         isDark,
         handleClose,
         fileInputRef
     }: AvatarUploadContextMenuParams
    ) => {
        const appState = useAppState();

        const handleFileSelect = () => {
            fileInputRef.current?.click();
        };

        return (
            <>
                <ContextMenu
                    isDark={isDark}
                    handleClose={handleClose}
                    items={[
                        {
                            onClick: handleFileSelect,
                            text: intl.get('AvatarUploadContextMenu.choose.from.library.avatar').d('Choose from library'),
                            Icon: CameraIcon
                        },
                        ...(hasAvatar ? [
                            {
                                onClick: (e: React.SyntheticEvent) => onRemoveAvatar(e as React.MouseEvent<HTMLElement>),
                                text: intl.get('AvatarUploadContextMenu.delete.photo').d('Delete photo'),
                                Icon: DeleteIcon
                            }
                        ] : []),
                    ]}
                />
            </>
        );
    }
);
